/* eslint-disable */
export default {
    page: {
        'LOADING': 'Загрузка...',
        'NOT_FOUND': 'Нам очень жаль, но такой страницы нет. :(',
        'LOADING_ERROR': 'Возникла проблема при загрузке данных. Попробуйте обновить страницу.'
    },
    notify: {
        'REFRESH_ERROR': 'Ключ доступа истек. Необходимо войти, используя логин и пароль.',
        'SERVER_ERROR': 'Произошла ошибка сервера.',
        'REQUEST_ERROR': 'Не удалось отправить запрос. Проверьте соединение с интернетом и попробуйте еще раз.'
    },
    header: {
        'LOGIN': 'Вход',
        'MY_EXAMS': 'Мои экзамены',
        'NEW_EXAMINER': 'Добавить экзаменатора',
        'NEW_EXAM': 'Добавить экзамен',
        'NEW_STUDENTS': 'Записать студентов'
    },
    exam: {
        'START': 'Начало',
        'END': 'Окончание',
        'TIMING': 'Время на подготовку',
        'PAPER': 'Билет',
        'TIME_UNIT': 'мин.',
        action: {
            'GIVE_PAPERS': 'Раздать билеты',
            'GIVE_PAPER': 'Выдать билет',
            'INVITE_STUDENT': 'Пригласить',
            'REVERT_STUDENT': 'На переподготовку',
            'REVERT_STUDENT_SHORT': 'Переподготовка',
            'FINISH': 'Завершить экзамен',
            'FINISH_SHORT': 'Завершить'
        }
    },
    exams: {
        'DELETE_FAILURE': 'Не удалось удалить экзамен.',
        'SAVE_FAILURE': 'Не удалось скачать ссылки на сессии.',
        'STUB': 'У вас пока что нет ни одного экзамена.'
    },
    status: {
        'NOT_STARTED': 'Не начал',
        'AWAITING_PAPER': 'Ожидает билет',
        'PREPARING': 'Готовится',
        'READY': 'Готов к сдаче',
        'STARTED': 'В процессе сдачи',
        'FINISHED': 'Экзамен завершён'
    },
    student: {
        'TIMING': 'Время на подготовку:',
        text: {
            'NOT_STARTED': 'Экзамен ещё не начался',
            'AWAITING_PAPER': 'Экзамен начался<br>Скоро вы получите билет',
            'PREPARING': '',
            'READY': '',
            'STARTED': '',
            'FINISHED': 'Экзамен завершён'
        },
        action: { 'READY': 'Готов сдавать' }
    },
    newExam: {
        'TITLE': 'Добавление экзамена',
        label: {
            'NAME': 'Название',
            'START': 'Начало',
            'END': 'Окончание',
            'TIMING': 'Время на подготовку (в минутах)',
            'COMMISSION': 'Члены комиссии'
        },
        awn: {
            'SEND_FORM': 'Создаем экзамен...',
            'SEND_PAPERS': 'Загружаем билеты...',
            'EXAM_SUCCESS': 'Экзамен создан!',
            'EXAM_FAILURE': 'Не удалось создать экзамен.',
            'PAPERS_SUCCESS': 'Билеты загружены! Все готово.',
            'PAPERS_FAILURE': 'Не удалось загрузить билеты, но экзамен создан. Вы можете отредактировать его.',
            'PROCESSING_FAILURE': 'Не удалось обработать файл. Проверьте содержимое файла и попробуйте еще раз.'
        },
        error: {
            'FIELD_REQUIRED': 'Вы заполнили не все поля',
            'COMMISSION_REQUIRED': 'Вы не указали членов комиссии',
            'PAPERS_REQUIRED': 'Вы не выбрали файл с билетами',
            'INVALID_FILE_TYPE': 'Неправильный тип файла'
        },
        'NAME_PLACEHOLDER': 'Введите название экзамена',
        'START_END_PLACEHOLDER': 'Выберите дату и время',
        'TIMING_PLACEHOLDER': 'Укажите время на подготовку',
        'UPLOAD_BUTTON': 'Загрузить билеты',
        'UPLOAD_HELP': 'Файл в формате XLSX со списком билетов (номер билета, заголовок, содержание)',
        'SUBMIT_BUTTON': 'Создать'
    },
    selectMembers: {
        label: {
            'SELECT': 'Нажмите, чтобы выбрать',
            'SELECTED': 'Выбран',
            'DESELECT': 'Нажмите, чтобы убрать'
        },
        'PLACEHOLDER': 'Выберите членов приемной комиссии',
        'SELECTION': 'В списке {n} человек(а)',
        'NO_OPTIONS': 'Список пуст'
    },
    datepicker: {
        'PLACEHOLDER': 'Выберите дату и время',
        'NEXT_MONTH': 'Следующий месяц',
        'PREV_MONTH': 'Предыдущий месяц',
        'TIME': 'Время:',
        'WEEKDAYS': [
            'Пн',
            'Вт',
            'Ср',
            'Чт',
            'Пт',
            'Сб',
            'Вс'
        ],
        'MONTHS': [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь'
        ],
        'DISPLAY': 'DD.MM.YYYY HH:mm'
    },
    newStudents: {
        'TITLE': 'Запись студентов',
        label: { 'EXAM': 'Экзамен' },
        awn: {
            'SEND_FORM': 'Добавляем студентов...',
            'UPLOAD_SUCCESS': 'Студенты добавлены! Скачивание ссылок на экзамен начнется автоматически.',
            'UPLOAD_FAILURE': 'Не удалось добавить студентов. Проверьте содержимое файла и попробуйте еще раз.',
            'LINKS_FAILURE': 'Не удалось сгенерировать ссылки. Попробуйте скачать их еще раз в карточке экзамена.',
            'PROCESSING_FAILURE': 'Не удалось обработать файл. Проверьте содержимое файла и попробуйте еще раз.'
        },
        error: {
            'EXAM_REQUIRED': 'Вы не выбрали экзамен',
            'STUDENTS_REQUIRED': 'Вы не выбрали файл со студентами',
            'INVALID_FILE_TYPE': 'Неправильный тип файла'
        },
        'UPLOAD_BUTTON': 'Загрузить список',
        'UPLOAD_HELP': 'Файл в формате XLSX со списком студентов (email, имя, фамилия)',
        'SUBMIT_BUTTON': 'Записать',
        'SUBMIT_DONE': 'Готово!',
        'DOWNLOAD_LINK': 'Скачать ссылки для студентов'
    },
    selectExam: {
        'PLACEHOLDER': 'Выберите экзамен',
        'NO_OPTIONS': 'Список пуст',
        label: {
            'SELECT': 'Нажмите, чтобы выбрать',
            'DESELECT': 'Нажмите, чтобы убрать'
        }
    },
    baseExamForm: {
        label: {
            'NAME': 'Название',
            'START': 'Начало',
            'END': 'Окончание',
            'TIMING': 'Время на подготовку (в минутах)',
            'COMMISSION': 'Члены комиссии',
            'PROCTORING': 'Тип прокторинга'
        },
        awn: { 'PROCESSING_FAILURE': 'Не удалось обработать файл. Проверьте содержимое файла и попробуйте еще раз.' },
        error: {
            'FIELD_REQUIRED': 'Вы заполнили не все поля',
            'COMMISSION_REQUIRED': 'Вы не указали членов комиссии',
            'PAPERS_REQUIRED': 'Вы не выбрали файл с билетами',
            'INVALID_FILE_TYPE': 'Неправильный тип файла',
            'PROCTORING_REQUIRED': 'Вы не указали тип прокторинга',
            'INVALID_DATETIME': 'Экзамен заканчивается раньше, чем начинается'
        },
        'NAME_PLACEHOLDER': 'Введите название экзамена',
        'START_END_PLACEHOLDER': 'Выберите дату и время',
        'TIMING_PLACEHOLDER': 'Укажите время на подготовку',
        'PROCTORING_PLACEHOLDER': 'Выберите тип прокторинга',
        'UPLOAD_BUTTON': 'Загрузить билеты',
        'UPLOAD_HELP': 'Файл в формате XLSX со списком билетов (номер билета, заголовок, содержание)',
        'ONLINE_PROC': 'Синхронный',
        'OFFLINE_PROC': 'Асинхронный',
        'IDENTIFICATION_PROC': 'Идентификация',
        'AUTO_PROC': 'Автоматический'
    },
    editExam: {
        'SUBMIT_BUTTON': 'Сохранить',
        'TITLE': 'Редактирование экзамена',
        awn: {
            'SEND_FORM': 'Сохраняем экзамен...',
            'SEND_PAPERS': 'Сохраняем билеты...',
            'EXAM_SUCCESS': 'Экзамен сохранен!',
            'EXAM_FAILURE': 'Не удалось отредактировать экзамен.',
            'PAPERS_SUCCESS': 'Билеты сохранены! Все готово.',
            'PAPERS_FAILURE': 'Не удалось отредактировать билеты, но экзамен сохранен.'
        }
    },
    newExaminer: {
        'TITLE': 'Добавление экзаменатора',
        'SUBMIT_BUTTON': 'Создать',
        'EMAIL_PLACEHOLDER': 'Введите корректный адрес электронной почты',
        'PASSWORD_PLACEHOLDER': 'Введите пароль для учетной записи экзаменатора',
        'PASSWORD2_PLACEHOLDER': 'Повторите введенный пароль',
        'FIRST_NAME_PLACEHOLDER': 'Имя',
        'LAST_NAME_PLACEHOLDER': 'Фамилия',
        'PASSWORD_HELP': 'Не короче восьми символов',
        error: {
            'FIELD_REQUIRED': 'Вы заполнили не все поля',
            'PASSWORD_MISMATCH': 'Пароли не совпадают',
            'COMPANY_REQUIRED': 'Вам не была назначена компания (вуз)'
        },
        awn: {
            'SEND_FORM': 'Добавляем экзаменатора...',
            'CREATE_SUCCESS': 'Экзаменатор добавлен!',
            'CREATE_ERROR': 'Не удалось добавить экзаменатора. Исправьте ошибки и попробуйте еще раз.'
        },
        label: {
            'EMAIL': 'Email',
            'PASSWORD': 'Пароль',
            'PASSWORD2': 'Подтверждение пароля',
            'FIRST_NAME': 'Имя',
            'LAST_NAME': 'Фамилия'
        }
    },
    profile: {
        'TITLE': 'Настройки профиля',
        'SUBMIT_BUTTON': 'Сохранить',
        'OLD_PASSWORD_PLACEHOLDER': 'Введите текущий пароль',
        'PASSWORD_PLACEHOLDER': 'Введите новый пароль',
        'PASSWORD2_PLACEHOLDER': 'Повторите новый пароль',
        awn: {
            'SEND_FORM': 'Сохраняем изменения...',
            'SUCCESS': 'Изменения сохранены.',
            'FAILURE': 'Не удалось сохранить изменения. Исправьте ошибки и попробуйте еще раз.'
        },
        section: { 'CHANGE_PASSWORD': 'Смена пароля' },
        error: { 'PASSWORD_MISMATCH': 'Пароли не совпадают' },
        label: {
            'EMAIL': 'Email',
            'OLD_PASSWORD': 'Текущий пароль',
            'PASSWORD': 'Новый пароль',
            'PASSWORD2': 'Подтверждение пароля'
        }
    },
    login: {
        'TITLE': 'Вход',
        'SUBMIT_BUTTON': 'Войти',
        'EMAIL_PLACEHOLDER': 'Адрес электронной почты',
        'PASSWORD_PLACEHOLDER': 'Пароль',
        label: {
            'EMAIL': 'Email',
            'PASSWORD': 'Пароль'
        },
        error: {
            'FIELD_REQUIRED': 'Вы заполнили не все поля',
            'INVALID_CREDENTIALS': 'Неверный email и/или пароль'
        }
    },
    filters: {
        'DATE_ASC': 'Сначала старые',
        'DATE_DESC': 'Сначала новые',
        'HIDE': 'Скрывать прошедшие'
    }
};
